var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "hazopDashboard", staticClass: "row bg-white" },
    [
      _c(
        "div",
        { staticClass: "col-2" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm dashborad",
              attrs: { title: "LBL0000969" },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("c-plant", {
                      staticClass: "none-bottom",
                      attrs: { type: "none", name: "plantCd" },
                      on: { datachange: _vm.plantChange },
                      model: {
                        value: _vm.searchParam.plantCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "plantCd", $$v)
                        },
                        expression: "searchParam.plantCd",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "main-card card riskassess-dashboard" },
                [
                  _c("div", { staticClass: "grid-menu grid-menu-3col" }, [
                    _c("div", { staticClass: "no-gutters row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "widget-chart bg-warning text-white widget-chart-hover",
                            },
                            [
                              _vm._m(0),
                              _c(
                                "div",
                                { staticClass: "widget-numbers" },
                                [
                                  _c("ICountUp", {
                                    attrs: {
                                      startVal: 0,
                                      endVal: _vm.plant.assessCnt,
                                      decimals: 0,
                                      duration: 4,
                                      options: _vm.countOptions,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "widget-subheading" }, [
                                _vm._v(_vm._s(_vm.$label("LBL0000970"))),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "widget-chart bg-danger text-white widget-chart-hover",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "icon-wrapper rounded" },
                                [
                                  _c("div", {
                                    staticClass:
                                      "icon-wrapper-bg bg-white opacity-2",
                                  }),
                                  _c("q-icon", {
                                    attrs: {
                                      name: "new_releases",
                                      coloe: "white",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "widget-numbers" },
                                [
                                  _c("ICountUp", {
                                    attrs: {
                                      startVal: 0,
                                      endVal: _vm.plant.riskbookCnt,
                                      decimals: 0,
                                      duration: 4,
                                      options: _vm.countOptions,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "widget-subheading" }, [
                                _vm._v(_vm._s(_vm.$label("LBL0000971"))),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "widget-chart bg-info text-white widget-chart-hover",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "icon-wrapper rounded" },
                                [
                                  _c("div", {
                                    staticClass:
                                      "icon-wrapper-bg bg-white opacity-2",
                                  }),
                                  _c("q-icon", {
                                    attrs: { name: "build", coloe: "white" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "widget-numbers" },
                                [
                                  _c("ICountUp", {
                                    attrs: {
                                      startVal: 0,
                                      endVal: _vm.plant.improvingCnt,
                                      decimals: 0,
                                      duration: 4,
                                      options: _vm.countOptions,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "widget-subheading" }, [
                                _vm._v(_vm._s(_vm.$label("LBL0000972"))),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "widget-chart bg-success text-white widget-chart-hover",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "icon-wrapper rounded" },
                                [
                                  _c("div", {
                                    staticClass:
                                      "icon-wrapper-bg bg-white opacity-2",
                                  }),
                                  _c("q-icon", {
                                    attrs: { name: "done", coloe: "white" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "widget-numbers" },
                                [
                                  _c("ICountUp", {
                                    attrs: {
                                      startVal: 0,
                                      endVal: _vm.plant.imporveCompleteCnt,
                                      decimals: 0,
                                      duration: 4,
                                      options: _vm.countOptions,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "widget-subheading" }, [
                                _vm._v(_vm._s(_vm.$label("LBL0000973"))),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]),
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm dashborad q-mt-sm",
              attrs: { title: "LBL0000974" },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("el-cascader-panel", {
                      staticStyle: { "min-height": "1050pxpx" },
                      attrs: { options: _vm.plant.processes },
                      on: { change: _vm.changeProcess },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.data.processName)),
                              ]),
                              scope.data.isAssess === "1"
                                ? _c(
                                    "span",
                                    [
                                      _c("q-icon", {
                                        staticClass: "blinking",
                                        attrs: {
                                          name: "handyman",
                                          color: "red-6",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c("div", { staticClass: "col-10" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "c-table",
                {
                  ref: "table",
                  attrs: {
                    title: "LBL0000950",
                    tableId: "safeHealSurvey01",
                    columns: _vm.gridSHI.columns,
                    data: _vm.gridSHI.data,
                    merge: _vm.gridSHI.merge,
                    gridHeight: "300px",
                    hideBottom: true,
                    filtering: false,
                    columnSetting: false,
                    usePaging: false,
                  },
                  on: { linkClick: _vm.linkClick },
                  scopedSlots: _vm._u([
                    {
                      key: "customArea",
                      fn: function ({ props, col }) {
                        return [
                          col.name === "sopNames" && props.row.sopNames
                            ? _vm._l(
                                _vm.chipDatas(props.row["sopNames"]),
                                function (item, index) {
                                  return _c(
                                    "q-chip",
                                    {
                                      key: index,
                                      staticStyle: {
                                        "margin-bottom": "4px !important",
                                      },
                                      attrs: {
                                        outline: "",
                                        square: "",
                                        color: "light-green",
                                        "text-color": "white",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(item) + " ")]
                                  )
                                }
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "table-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.gridSHI.data &&
                                  _vm.gridSHI.data.length > 0,
                                expression:
                                  "gridSHI.data && gridSHI.data.length > 0",
                              },
                            ],
                            attrs: { label: "LBL0000951", icon: "assignment" },
                            on: { btnClicked: _vm.printChecklist },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-10" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm dashborad",
                  attrs: { noHeader: true },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("apexchart", {
                          ref: "chart",
                          attrs: {
                            height: "260",
                            type: "bar",
                            width: _vm.chart.chartWidth,
                            options: _vm.chart.chartOptions,
                            series: _vm.chart.series,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c("div", { staticClass: "col-2" }, [
            _c("div", { staticClass: "main-card card riskassess-dashboard" }, [
              _c("div", { staticClass: "grid-menu grid-menu-3col" }, [
                _c("div", { staticClass: "no-gutters row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12", on: { click: _vm.noneImprove } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "widget-chart bg-deep-orange text-white widget-chart-hover",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "icon-wrapper rounded" },
                            [
                              _c("div", {
                                staticClass:
                                  "icon-wrapper-bg bg-white opacity-2",
                              }),
                              _c("q-icon", {
                                attrs: {
                                  name: "warning_amber",
                                  coloe: "white",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "widget-numbers" },
                            [
                              _c("ICountUp", {
                                attrs: {
                                  startVal: 0,
                                  endVal: _vm.process.noneImprovingCnt,
                                  decimals: 0,
                                  duration: 4,
                                  options: _vm.countOptions,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "widget-subheading" }, [
                            _vm._v(_vm._s(_vm.$label("LBL0000975"))),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12", on: { click: _vm.noneRiskbook } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "widget-chart bg-danger text-white widget-chart-hover",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "icon-wrapper rounded" },
                            [
                              _c("div", {
                                staticClass:
                                  "icon-wrapper-bg bg-white opacity-2",
                              }),
                              _c("q-icon", {
                                attrs: { name: "new_releases", coloe: "white" },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "widget-numbers" },
                            [
                              _c("ICountUp", {
                                attrs: {
                                  startVal: 0,
                                  endVal: _vm.process.nonRiskbookCnt,
                                  decimals: 0,
                                  duration: 4,
                                  options: _vm.countOptions,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "widget-subheading" }, [
                            _vm._v(_vm._s(_vm.$label("LBL0000971"))),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("c-tab", {
                attrs: {
                  type: "tabcard",
                  align: "left",
                  inlineLabel: true,
                  tabItems: _vm.tabItems,
                  height: "850px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (tab) {
                      return [
                        _c(tab.component, {
                          tag: "component",
                          attrs: { searchParam: _vm.searchParam },
                          on: {
                            "update:searchParam": function ($event) {
                              _vm.searchParam = $event
                            },
                            "update:search-param": function ($event) {
                              _vm.searchParam = $event
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-wrapper rounded" }, [
      _c("div", { staticClass: "icon-wrapper-bg bg-white opacity-2" }),
      _c("i", { staticClass: "pe-7s-share text-white" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }